<template>
  <div id="app" v-cloak>
    <MyHeader v-if="!$route.meta.hideHeader" :lineType="data_lineType" :data_tel="data_tel" />
    <router-view :key="$isZh"></router-view>
    <div class="scroll-top" @click="scrollTop" v-if="!$route.meta.hideFooter">
      <span class="iconfont icon-zuojiantou"></span>
    </div>

    <a class="qr-box" href="https://wa.me/8614776148891" target="_blank">
      <img src="../src/assets/images/kefupic.png" calss="img-auto" alt="">
      <!-- <span>{{ $isZh ?'客服' : 'Customer Service'}}</span> -->
    </a>
    <MyFooter v-if="!$route.meta.hideFooter" :data_system="data_system" :data_tel="data_tel" />
  </div>
</template>

<script>
// import chineseConverter from 'chinese-converter';
import MyHeader from './components/MyHeader.vue'
import MyFooter from './components/MyFooter.vue'
import { getHomeInfo } from '@/api/api.js'
export default {
  name: 'App',
  data() {
    return {
      data_lineType: [],
      data_tel: {},
      data_system: {}
    }
  },
  created() {

    !localStorage.getItem('language') && localStorage.setItem('language', 'zh-CN')
    this.getHomeInfo()
  },
  methods: {
    scrollTop() {
      window.scrollTo(0, 0)
    },
    getHomeInfo() {
      let _this = this
      getHomeInfo().then(res => {
        _this.data_lineType = res.data.data_lineType
        _this.data_tel = res.data.data_tel
        _this.data_system = res.data.data_system
        localStorage.setItem('system', JSON.stringify(res.data.data_system))
        localStorage.setItem('data_tel', JSON.stringify(res.data.data_tel))

        let index = res.data.data_system.findIndex(item => item.type == 6)
        let index2 = res.data.data_system.findIndex(item => item.type == 1)

        let pay_type_content = res.data.data_system[index][this.$isZh ? 'post_content' : 'post_content_en']

        localStorage.setItem('pay_type_content', JSON.stringify(pay_type_content))
      })
    },

  },
  components: {
    MyHeader,
    MyFooter
  },

}
</script>

<style lang="scss" scoped>
#app {
  [v-cloak] {
    display: none;
  }

  .scroll-top {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    text-align: center;
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    right: 6px;
    bottom: 100px;
    color: #fff;
    border-radius: 50%;
    transform: rotate(90deg);
    z-index: 999;
  }

  .qr-box {
    position: fixed;
    left: 6px;
    bottom: 50%;
    z-index: 999;
    font-size:30px;
    width: 100px;
    height: 100px;
    text-align: center;
    span{
      margin-top: 4px;
    }
    img{
      display: block;
      width: 100%;
      height: 100%;
    }

  }
}
</style>
